/* eslint-disable */
const Routes = {
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/modules/authentication-module/pages/login-page/login-page"),
      meta: {
        requiresAuth: false,
      },
    },
    { path: '/login/callback', component: () => import("@/modules/authentication-module/pages/login-callback/login-callback") },
    { path: '/initialize', component: () => import("@/modules/authentication-module/pages/initialize/initialize") },
    {
      path: "/register",
      name: "Register",
      component: () => import("@/modules/authentication-module/pages/register-page/register-page"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/forgot-password",
      name: "Forgot Password",
      component: () => import("@/modules/authentication-module/pages/forgot-password-page/forgot-password-page"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/admin",
      component: () => import('@/views/dashboard/Index'),
      meta: {
        requiresAuth: true,
        isDashboardRoot: true,
      },
      children: [
        {
          name: 'Dashboard',
          path: "dashboard",
          component: () => import("@/modules/private-module/pages/dashboard-page/dashboard-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Patients',
          path: "patients",
          component: () => import("@/modules/private-module/pages/patients-page/patients-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage Templates',
          path: "manage-templates",
          component: () => import("@/modules/private-module/pages/manage-templates/manage-templates"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage Groups',
          path: "manage-groups/:activeTab?",
          props: true,
          component: () => import("@/modules/private-module/pages/manage-groups-page/manage-groups-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Survey Insights',
          path: "survey-insights",
          component: () => import("@/modules/private-module/pages/survey-insights/survey-insights"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Google Review',
          path: 'google-review',
          props: true,
          component: () => import('@/modules/private-module/pages/google-business-review/GoogleReviews'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage Group Patients',
          path: "manage-group-patients/:groupId",
          props: true,
          component: () => import("@/modules/private-module/pages/manage-group-patients/manage-group-patients"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage Dynamic Group',
          path: "manage-dynamic-groups",
          props: true,
          component: () => import("@/modules/private-module/pages/manage-dynamic-groups-page/manage-dynamic-groups-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Dynamic Group Patients',
          path: "manage-dynamic-group-patients/:groupId",
          props: true,
          component: () => import("@/modules/private-module/pages/dynamic-group-patients-page/dynamic-group-patients-page"),
          meta: {
            requiresAuth: true,
          }
        }
      ]
    },
    {
      path: "/pos-admin",
      component: () => import('@/modules/pos-admin-module/index'),
      meta: {
        requiresAuth: true,
        isDashboardRoot: true,
      },
      children: [
        {
          name: 'Manage Clinics',
          path: "manage-clinics",
          component: () => import("@/modules/pos-admin-module/pages/manage-clinics-page/manage-clinics-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage Medical Groups',
          path: "manage-medical-groups",
          component: () => import("@/modules/pos-admin-module/pages/manage-medical-groups-page/manage-medical-groups-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage Messaging Services',
          path: "manage-messaging-services",
          component: () => import("@/modules/pos-admin-module/pages/manage-messaging-services-page/manage-messaging-services-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage System Templates',
          path: "manage-system-templates",
          component: () => import("@/modules/pos-admin-module/pages/manage-system-template-page/manage-system-template-page"),
          meta: {
            requiresAuth: true,
          },
        },
        {
          name: 'Manage Practice Templates',
          path: "manage-practice-templates",
          component: () => import("@/modules/pos-admin-module/pages/manage-practice-template-page/manage-practice-template-page"),
          meta: {
            requiresAuth: true,
          },
        }
      ]
    },
  ],
};

export default Routes;
